import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Field } from '@adornis/baseql/decorators.js';
import { Entity } from '@adornis/baseql/decorators/entity.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';

@Entity()
export class EmploymentPermitMetaInfoMissingSection extends AdornisEntity {
  static override _class = 'EmploymentPermitMetaInfoMissingSection';

  constructor(doc: PartialEntityData<EmploymentPermitMetaInfoMissingSection>) {
    super(doc);
  }

  static override resolveID(entity: any): string {
    // should always be set but on creating the entity it might be empty temporarily
    return entity.sectionID ?? A.getGloballyUniqueID();
  }

  // the section of the bg like 1,2,...
  // this is used to identify the section also in the missing fields section of the form
  @Field(type => Int)
  sectionID!: number;

  // a name for the section. Only used for human readable format in the ui
  @Field(type => String)
  sectionName!: string;

  // a reason why the section was not sent. Maybe the generator function created an error here. Can be technical.
  @Field(type => String)
  reason: Maybe<string>;
}

@Entity()
export class EmploymentPermitMetaInfo extends AdornisEntity {
  static override _class = 'EmploymentPermitMetaInfo';

  constructor(doc: PartialEntityData<EmploymentPermitMetaInfo>) {
    super(doc);
  }

  // describes on which date the inital automatic email was sent to the bg-add
  // if empty, the email was never sent automatically
  @Field(type => Date)
  initialEmailSentAt: Maybe<Date>;

  // if only automatic the two dates will be the same
  // if a user manually sent an email, this will be updated
  @Field(type => Date)
  lastEmailSentAt: Maybe<Date>;

  // which sections where not sent
  @Field(type => [EmploymentPermitMetaInfoMissingSection], { default: v => v ?? [] })
  missingSectionsInLastMail: Maybe<EmploymentPermitMetaInfoMissingSection[]>;
}
